import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useIntl } from 'react-intl';

const ShareLinksModalUserListItem = ({ link }) => {
  const [linkCopied, setLinkCopied] = useState(false);

  const intl = useIntl();

  const copyLink = () => {
    setLinkCopied(true);
    setTimeout(() => {
      setLinkCopied(false);
    }, 2000);
  };

  const user = link.shared_user;
  const email = link.shared_email;

  return (
    <div className="share-user share-item">
      {user && user.avatar ? (
        <div className="user-avatar share-avatar">
          <img src={user.avatar} alt={user.display_name} className="avatar avatar-40" />
        </div>
      ) : (
        <div className="user-avatar share-avatar">
          <div className={`avatar avatar-40 icon-avatar ${user ? 'light-' : ''}gray`}>
            <i className={`fas fa-${email ? 'at' : 'user'}`} />
          </div>
        </div>
      )}
      <div className="share-item-body share-user-body">
        <h6 className="share-item-title">
          {(user && user.name) ? user.name : email}
        </h6>
        {(user && user.name) && (
          <span className="share-item-details share-user-details">
            {user.email}
          </span>
        )}
      </div>
      <div className="share-views">
        <i className="far fa-eye" />{' '}
        {link.total_views}
      </div>
      <div className="share-item-actions share-user-actions">
        <CopyToClipboard
          text={`${window.location.origin}/shares/${link.uuid}`}
          options={{
            format: 'text/plain',
          }}
          onCopy={copyLink}
        >
          {linkCopied ? (
            <span>{intl.formatMessage({ defaultMessage: 'Copied' })}</span>
          ) : (
            <a href="#copy" onClick={(e) => { e.preventDefault(); }}>
              <i className="far fa-copy" />
            </a>
          )}
        </CopyToClipboard>
      </div>
    </div>
  );
};

ShareLinksModalUserListItem.propTypes = {
  link: PropTypes.object.isRequired,
};

export default ShareLinksModalUserListItem;
